import image from 'img/mascot/bite_looks_out.png';
import React from 'react';
import { OverquotaInfoBlock } from 'reactApp/ui/OverquotaInfoBlock/OverquotaInfoBlock';

import styles from './DiscountOnRemoveModal.css';

interface DiscountOnRemoveBannerProps {
    text: string;
}

export function DiscountOnRemoveBanner({ text }: DiscountOnRemoveBannerProps) {
    return (
        <div className={styles.banner}>
            <img src={image} alt={text} width={236} height={158} className={styles.imageBanner} />
            <div className={styles.bannerContainer}>
                <OverquotaInfoBlock />
                <div className={styles.arrowBlock}>
                    <ArrowFrame />
                    <div className={styles.discountInfo}>{text}</div>
                </div>
            </div>
        </div>
    );
}

function ArrowFrame() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="108" height="155" viewBox="0 0 108 155" fill="none">
            <g clipPath="url(#clip0_94_16298)">
                <path
                    d="M65.2599 25.8085C100.37 47.2149 120.182 87.4812 88.5297 117.356C75.7342 127.843 59.1831 129.822 46.6872 124.898C17.5805 113.426 15.7742 54.6094 36.7419 64.0134C41.3724 66.0901 42.7016 71.4819 42.0018 76.0676C37.8809 103.072 2.97613 114.942 -16.4995 102.841M65.2599 25.8085C65.8107 29.0723 66.6698 37.1749 65.7 43.4754M65.2599 25.8085C67.8847 25.6705 74.9787 24.7242 82.3564 22.0433"
                    stroke="var(--vkui--color_text_accent)"
                    strokeWidth="4"
                    strokeLinecap="square"
                />
            </g>
            <defs>
                <clipPath id="clip0_94_16298">
                    <rect width="108" height="155" fill="white" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
